import clsx from 'clsx'
import { forwardRef, HTMLAttributes } from 'react'
import styles from './FormComponentBodySlotUI.module.scss'

export const FormComponentBodySlotUI = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ children, className, ...props }, ref) => (
    <div className={clsx(styles.slot, className, 'form-component-body-slot')} ref={ref} {...props}>
      {children}
    </div>
  ),
)
